import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";
import { Briefcase } from "lucide-react";

export default function AdminJobs() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api.get("/jobs", { params: { page_size: 100 } }).then((r) => setJobs(r.data.jobs)).catch(() => {}); }, []);

  return (
    <AdminShell>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-5">Job Management</h1>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-slate-400 bg-slate-50 border-b border-slate-100"><th className="py-3 px-4 font-medium">Title</th><th className="py-3 px-4 font-medium">Company</th><th className="py-3 px-4 font-medium">Location</th><th className="py-3 px-4 font-medium">Exp</th><th className="py-3 px-4 font-medium">Status</th></tr></thead>
          <tbody>
            {jobs.map((j) => (
              <tr key={j.job_id} className="border-b border-slate-50 hover:bg-slate-50">
                <td className="py-3 px-4 font-medium text-slate-800"><Link to={`/jobs/${j.job_id}`} className="hover:text-[#D96B27] flex items-center gap-2"><Briefcase className="w-4 h-4 text-slate-400" />{j.title}</Link></td>
                <td className="py-3 px-4 text-slate-600">{j.company_name}</td>
                <td className="py-3 px-4 text-slate-600">{j.location}</td>
                <td className="py-3 px-4 text-slate-600">{j.min_experience}-{j.max_experience} yrs</td>
                <td className="py-3 px-4"><span className="text-xs bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded">{j.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
}
